import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_replenishment_template_hdr_RowClass} from '../../../dbschema/bl_inv_stock_replenishment_template_hdr.model';

export class StockReplenishmentTemplateHdrModel extends BaseContainerModel {
  bl_inv_stock_replenishment_template_hdr: bl_inv_stock_replenishment_template_hdr_RowClass = new bl_inv_stock_replenishment_template_hdr_RowClass();
}
